import { render, staticRenderFns } from "./ScholarshipManagement.vue?vue&type=template&id=898abbda&scoped=true"
import script from "./ScholarshipManagement.vue?vue&type=script&lang=js"
export * from "./ScholarshipManagement.vue?vue&type=script&lang=js"
import style0 from "./ScholarshipManagement.vue?vue&type=style&index=0&id=898abbda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "898abbda",
  null
  
)

export default component.exports